import { alert } from 'actions/flash'
import { buildTranslate } from 'locales'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { ACTIVATION_PATH } from '../routes'

const t = buildTranslate('recovery_ai.preparer')

// The activation deep link a preparer hands to an admin, plus the copy action.
//
// Decision 5: a PLAIN deep link, built client-side. AI-924 owns the signed/tokenised
// form.
//
// Deliberately window.location.origin and NOT REACT_APP_MERCHANT_ROOT_URL: every other
// consumer treats that var as the LEGACY Rails dashboard host (it is literally assigned
// to `oldDashboardPath` in CampaignCenter, and .env.example points it at
// merchant.thanx-web.test). ACTIVATION_PATH is a route in THIS app, so prefixing it
// with the legacy host yields a link that redirects to the dashboard root with the path
// dropped. The origin is correct by construction — the preparer is looking at this
// page, in this origin — and with Notify gated off until AI-923 this link is the only
// handoff output the modal actually ships.
export const useActivationLink = (): {
  activationUrl: string
  copyLink: () => Promise<void>
} => {
  const dispatch = useDispatch()
  const activationUrl = `${window.location.origin}${ACTIVATION_PATH}`

  const copyLink = useCallback(async () => {
    // navigator.clipboard needs a secure context, and writeText rejects on a denied
    // permission or an unfocused document. Confirm only on an actual write, and say
    // so when it fails — the URL renders as selectable text above the button, so
    // there IS a manual fallback, but a SILENT failure leaves the preparer believing
    // they copied something.
    try {
      await navigator.clipboard.writeText(activationUrl)
    } catch {
      dispatch(
        alert({ key: 'danger', message: t('link_copy_failed'), timeout: 5 })
      )
      return
    }
    dispatch(alert({ key: 'success', message: t('link_copied'), timeout: 5 }))
  }, [activationUrl, dispatch])

  return { activationUrl, copyLink }
}

export default useActivationLink
